/**
 * this is the index for a browserify-build
 * which produces a single file that can be embedded into the html
 * and used via window.NxDB
 */

import '@babel/polyfill';
import * as NxDB from './index.js';

(window as any)['NxDB'] = NxDB;
